export default "__VITE_ASSET__0eU0nsiw__"